import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges
} from '@angular/core';
import { InternalLinkService } from '@bling-fe/shared/services';
import Autolinker from 'autolinker';
import { DirectivesModule } from '../../directives/directives.module';

/**
 * The one way to render user/admin-authored HTML: classifies every link as
 * internal/external, routes internal ones in-app and upgrades their text to
 * the linked resource's real name (group, post, event, document) per viewer.
 * Optional autolinking for content whose bare URLs are not anchors yet.
 */
@Component({
  selector: 'fl-rich-content',
  standalone: true,
  imports: [DirectivesModule],
  template: `
    <div
      flResolveLinkTitles
      [innerHTML]="rendered"
    ></div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RichContentComponent implements OnChanges {
  @Input() html: string | null | undefined;
  @Input() autolink = false;

  rendered = '';

  constructor(private internalLinkService: InternalLinkService) {}

  ngOnChanges(): void {
    const linked = this.autolink
      ? Autolinker.link(this.html ?? '', { newWindow: false })
      : (this.html ?? '');
    this.rendered = this.internalLinkService.normalizeLinks(linked);
  }
}
